<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  props: ['language','baseUrl','themePath'],
  data(){
    return {
      currLang: "pt",
      mainColors:{
        'artes-e-humanidades' : "#8a8acd",
        'ciencias-sociais' : "#9b3232",
        'ciencias-exatas-e-da-engenharia' : "#649fd1",
        'ciencias-da-vida' : "#fea461",
        'escola-superior-de-saude' : "#91E2C3",
        'escola-superior-de-tecnologias-e-gestao' : "#ffcc66",
      },
      secundaryColors: {
        'artes-e-humanidades' : "#353589",
        'ciencias-sociais' : "#631515",
        'ciencias-exatas-e-da-engenharia' : "#206d9d",
        'ciencias-da-vida' : "orange",
        'escola-superior-de-saude' : "#04b671",
        'escola-superior-de-tecnologias-e-gestao' : "#f1a308",
      }
    }
  },
  created(){
    this.currLang = this.language;
    this.$store.commit("setLanguage",this.language);
  },
  provide(){
    return{
      lang: this.currLang,
      baseUrl: this.baseUrl,
      secundaryColors: this.secundaryColors,
      mainColors: this.mainColors
    }
  }
}
</script>


<style>

.content {
  padding-top: 80px;
  padding-bottom: 80px;
}

/*Responsive - ecrãs desktop pequenos*/
@media (max-width: 1440px) {
  .content {
    padding-top: 50px;
    padding-bottom: 50px;
  }

}
/*Responsive - iphone*/
@media (max-width: 767px) {
  .row .row {
    margin-right: 0;
    margin-left: 0;
  }

  .content {
    padding-top: 30px;
    padding-bottom: 10px;
  }

}

.artes-e-humanidades{
  background-color: #8a8acd;
}

.artes-e-humanidades.secondColor{
  background-color: #4646a5;
}

.escola-superior-de-tecnologias-e-gestao{
  background-color: #ffcc66;
}

.escola-superior-de-tecnologias-e-gestao.secondColor{
  background-color: #f1a308;
}

.escola-superior-de-saude{
  background-color: #91E2C3;
}

.escola-superior-de-saude.secondColor{
  background-color: #04b671;
}

.ciencias-da-vida{
  background-color: #fea461;
}

.ciencias-da-vida.secondColor{
  background-color: orange;
}


.ciencias-sociais{
  background-color: /*#FF5A5AFF*/
      #9b3232;
}

.ciencias-sociais.secondColor{
  background-color: #761818;
}

.ciencias-exatas-e-da-engenharia{
  background-color: #649fd1;
}

.ciencias-exatas-e-da-engenharia.secondColor{
  background-color: lightskyblue;
}


@font-face {
  font-family: "Montserrat Bold";
  src: url("./assets/fonts/Montserrat-Bold.otf") format("opentype");
  font-display: swap;
}

@font-face {
  font-family: "Montserrat Light";
  font-display: swap;
  src: url("./assets/fonts/Montserrat-Light.otf") format("opentype");
}

@font-face {
  font-family: "Montserrat";
  font-display: swap;
  src: url("./assets/fonts/Montserrat-Regular.otf") format("opentype");
}

@font-face {
  font-family: "Montserrat SemiBold";
  font-display: swap;
  src: url("./assets/fonts/Montserrat-SemiBold.otf") format("opentype");
}

@font-face {
  font-family: "Montserrat Thin";
  font-display: swap;
  src: url("./assets/fonts/Montserrat-Thin.otf") format("opentype");
}

@font-face {
  font-family: "PT Sans";
  /*src: url("./assets/fonts/PTS55F.ttf");*/
  src: url("./assets/fonts/PTSans.woff2") format('woff2');
}

@font-face {
  font-family: "PT Sans Bold Italic";
  /*src: url("./assets/fonts/PTS76F.ttf");*/
  src: url("./assets/fonts/PTSansBoldItalic.woff2") format('woff2');
}

#app .row{
  max-width: 100%;
}

.darkbackground{
  background-color: rgb(135, 206, 250) !important;
}

</style>
